export default {
    getUserId: (item) => {
        return item["user_id"]
    },
    getUsername: (item) => {
        return item["username"]
    },
    getAvatarHost: (item) => {
        return item["avatar"]["host"]
    },
    getAvatarName: (item) => {
        return item["avatar"]["name"]
    },
}
